import Vue from "vue";
import VueX from "vuex";

import auth from "./auth";
import participant from "./participant";
import room from "./room";
import hostAccount from "./host-account";
import hostRoom from "./host-room";
import hostDevice from "./host-device";
import calendar from "./calendar";
import authParticipant from "./auth-participant";

import participantEvent from "./participant-event";


import VuexLocalStorage from "../modules/LocalStorage";

Vue.use(VueX);

export default new VueX.Store({
  modules: {
    auth,
    participant,
    room,
    hostAccount,
    hostRoom,
    hostDevice,
    calendar,
    authParticipant,
    participantEvent
  },
  plugins: [VuexLocalStorage]
});
